import React from 'react';
import PropTypes from 'prop-types';
import ShortId from 'shortid';
import HeadingActions from '../../components/HeadingActions';

const PageLinks = props => {
  return (
    <HeadingActions
      isTransportation={props.isTransportation}
      isDirty={props.isDirty}
      key={ShortId.generate()}
      transportationPath={props.transportationPath}
      showPath={props.showPath}
      editPath={props.editPath}
      historyPath={props.historyPath}
      discussion={{
        ...props.discussion,
        iconOnly: true,
        serviceRequestId: props.serviceRequestId,
      }}
      changeHistoryPath={props.changeHistoryPath}
      discussionPath={props.discussionPath}
    />
  );
};

PageLinks.propTypes = {
  partyId: PropTypes.string,
  serviceRequestId: PropTypes.string,
  discussion: PropTypes.object,
  isDirty: PropTypes.bool,
  isTransportation: PropTypes.bool,
  transportationPath: PropTypes.string,
  showPath: PropTypes.string,
  editPath: PropTypes.string,
  historyPath: PropTypes.string,
  changeHistoryPath: PropTypes.string,
};

export default PageLinks;
